export const selectRightSidebar = (state: IState) => state.rightSidebar
